import * as React from 'react';
import ouiDom from '@goldwasserexchange/oui-dom';
import { TopModel } from '@goldwasserexchange/react-topmodel';
import { Trans } from '@lingui/macro';
import { GEPhoneNumber } from '../PhoneNumber';
import { Space } from '../Space';
import { CreateAccountLink, ReturnButton } from './components';
import ouiStyle from '@goldwasserexchange/oui-style';

export const CreateAccountForBuy = (props: {
  container?: ouiStyle.InStyleWithMediaQueries['container'],
}) => {
  const {
    container,
  } = props;
  return (
    <ouiDom.HeadingSection.HeadingSection
      name="createAccountForBuy"
      index={0}
      paddingHorizontal="double"
      container={container}
    >
      <TopModel
        name="HeadingSectionTitleContainer-createAccountForBuy"
        textAlign="center"
        lineFactor={1}
        paddingBottom="simple"
      >
        {ouiDom.HeadingSection.DomH2}
      </TopModel>
      <TopModel
        name="HeadingSectionTitleContent-createAccountForBuy"
      >
        <Trans>
          Vous ne possédez pas encore de compte chez Goldwasser Exchange
        </Trans>
      </TopModel>
      <TopModel
        name="HeadingSectionIntroContent-createAccountForBuy"
      >
        <Trans>
          Vous pouvez dès à présent ouvrir un compte :
        </Trans>
      </TopModel>
      <TopModel
        name="HeadingSectionIntroContainer-createAccountForBuy"
        textAlign="center"
      >
        {ouiDom.P.DomPContainer}
      </TopModel>
      <CreateAccountLink />
      <ouiDom.P.P
        textAlign="center"
      >
        pour plus d'informations n'hésitez pas à nous contacter au
        <Space />
        <GEPhoneNumber />
      </ouiDom.P.P>
      <ReturnButton />
    </ouiDom.HeadingSection.HeadingSection>
  );
};
